import React from 'react';

function CustomerCharing({data}) {

    return (
        <div className="column pt-24">
            <div className="boxT1">
                <h3>
                    Customer charging by location
                    <span>Overall</span>
                </h3>
                {data.length > 0 ?
                    <div className="graphDeta pt-8">
                        {data.map((value, key)=>{
                            return(
                                <p>
                                    <span>{value?.postal_code} - {value?.charging_address} </span>
                                    <span className="count b">{value?.total_charge_percentage} %</span>
                                </p>
                            )
                            })
                            }
                    </div>
                    :
                    <div className="graphDeta pt-8">
                        <p>No data found</p>
                    </div>
                }
            </div>
        </div>
    );
}

export default CustomerCharing;